import { createVuetify, type VuetifyOptions } from 'vuetify';
import { fa } from 'vuetify/iconsets/fa';
import { aliases, mdi } from 'vuetify/iconsets/mdi';
import '@mdi/font/css/materialdesignicons.css';

import { getLocaleCode } from '@bv/utils/i18n';

export const vuetify = createVuetify({
  locale: {
    locale: getLocaleCode(),
    rtl: {
      ar: true,
    },
  },
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      fa,
      mdi,
    },
  },
});

export default vuetify;

export { VuetifyOptions };
